/**
 * Created by apokdev on 6/6/17.
 */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { getJSON } from "../constants/network";
import { hideHeader } from "../constants/functions";
import routes from "../constants/routes";
import BreadCrumb from "./Breadcrumbs";
import Regiones from "./Regiones";
import SlickPoi from "./SlickPoi";

export default class extends Component{
    constructor(props){
        super(props)
        this.state = {
            ruta: {
                region: { slug: ""},
                imagen: {
                    url: '',
                    thumbnail: ''
                },
                sectores:[],
                pois_por_tipo: [
                    {
                        tipo: {nombre: "",id: ""},
                        pois: []
                    }
                ]
            },
            favoritos: [],
            destacados: [],
            imagenes: []
        }
    }
    cargarRuta(props){
        getJSON(routes.rutaById + props.match.params.rutaId)
            .then((result) => {
                this.setState({
                    ruta: result.data
                });
            });
        getJSON(routes.rutaById+props.match.params.rutaId+"/pois?destacados=1")
            .then((result) => {
                this.setState({
                    destacados: result.data
                });
            });
        getJSON(`${routes.rutaById}${props.match.params.rutaId}/imagenes`)
            .then(result => {
                this.setState({
                    imagenes: result.data
                });
                this.cargarImagenes(this.state.imagenes);
            })
    }

    componentDidMount(){
        hideHeader();
        this.cargarRuta(this.props);
    }
    componentWillReceiveProps(nextProps) {
        this.cargarImagenes([]);
        this.cargarRuta(nextProps);
    }
    componentDidUpdate(prevProps){
        if(prevProps.match.params.rutaId !== this.props.match.params.rutaId) {
            this.cargarRuta();
        }
    }
    cargarImagenes(imagenes){
        // let divImagenes = document.getElementById('imagenes-estado');
        // if(imagenes && imagenes.length) {
        //     ReactDom.render(<PoiImagenes imagenes={imagenes}/>, divImagenes);
        // }else{
        //     ReactDom.unmountComponentAtNode(divImagenes);
        // }
    }
    render(){
        let ruta = this.state.ruta;
        return (
            <div>
                <div id="cambio-sector" className={`${this.state.ruta.region.slug}`}>
                    <div className="contenedor-sector">
                        <BreadCrumb links={[
                            {url: `/#/estado/${ruta.estado}`, text: ruta.estado},
                            {url: `/#/estado/${ruta.estado}/rutas/_`, text: "Rutas"},
                            {url: null, text: ruta.nombre}
                        ]}/>
                    </div>
                </div>
                <div className="contenedor-sector">
                    <div className="row">
                        <div className="col-sm-3 hidden-xs">
                            {
                                ruta.pois_por_tipo.slice(0,2).map((poi) => {
                                    return (
                                        <SlickPoi
                                            id={"slick_"+poi.tipo.id+"_"+ruta.id+"_vertical"}
                                            key={poi.tipo.id}
                                            poi={poi}
                                            region={ruta.region.slug}
                                            vertical={true}/>
                                    )
                                })
                            }
                        </div>
                        <div className="col-sm-9 col-xs-12">
                            <h3 className="nombre-ruta">{ruta.nombre}</h3>
                            <div className="encabezado-ruta">
                                {
                                    (function(){
                                        if(ruta.imagen && ruta.imagen.url){
                                            return (
                                                <div className="imagen-ruta">
                                                    <img src={ruta.imagen.url} alt=""/>
                                                </div>
                                            );
                                        }
                                    })()
                                }
                                <h4><div className="comfortaasucks">&iquest;</div>Cómo llegar?</h4>
                                <p dangerouslySetInnerHTML={{__html: ruta.direcciones}}/>
                            </div>
                            <div className="info-ruta">
                                <h4><div className="comfortaasucks">&iquest;</div>Qué hay por aquí?</h4>
                                <p dangerouslySetInnerHTML={{__html: ruta.alrededores}}/>
                            </div>
                            <div className="pois-favoritos">
                                <ul>
                                    {
                                        this.state.destacados.map((poi)=>{
                                            let imagen = "/img/brujula_oficial_gris.png";
                                            if(poi.imagenes && poi.imagenes.length){
                                                imagen = poi.imagenes[0].thumbnail;
                                            }
                                            return (
                                                <Link key={poi.id} to={`/poi/${poi.slug}`}>
                                                    <li className={`${poi.region.slug}`}>
                                                        <img src={imagen} alt=""/>
                                                        <div className="texto">
                                                            {poi.nombre}
                                                        </div>
                                                    </li>
                                                </Link>
                                            )
                                        })
                                    }
                                </ul>
                            </div>

                            <div className="col-xs-12 visible-xs">
                                {
                                    ruta.pois_por_tipo.slice(0,2).map((poi) => {
                                        return (
                                            <SlickPoi
                                                id={"slick_"+poi.tipo.id+"_"+ruta.id+"_horizontal"}
                                                key={poi.tipo.id}
                                                poi={poi}
                                                region={ruta.region.slug}
                                                vertical={false}/>
                                        )
                                    })
                                }
                            </div>
                            <div className="col-sm-12 col-xs-12">
                                {
                                    ruta.pois_por_tipo.slice(2).map((poi) => {
                                        return (
                                            <SlickPoi
                                                id={"slick_"+poi.tipo.id+"_"+ruta.id+"_horizontal"}
                                                key={poi.tipo.id}
                                                poi={poi}
                                                region={ruta.region.slug}
                                                vertical={false}/>
                                        )
                                    })
                                }
                            </div>
                            {/*<div className="col-sm-12 col-xs-12">*/}
                                {/*<h3>Galería</h3>*/}
                                {/*<div className="poi-detalle" id="imagenes-estado"/>*/}
                            {/*</div>*/}
                        </div>
                    </div>

                    <p className="link_volver">
                        <a onClick={() => this.props.history.goBack()}>
                            <span className="glyphicon glyphicon-triangle-left"/>
                            &nbsp;Volver
                        </a>
                    </p>
                    <p>&nbsp;</p>
                </div>
                <div className="include-region">
                    <Regiones completo={false}/>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/RutaInfo.js